module.exports = __webpack_public_path__ + "static/img/logo.6cab52b2.png";